import React from 'react'
import { Formik, Field, Form } from "formik";
import { FaArrowRight, FaEnvelope, FaShieldAlt } from 'react-icons/fa';

export const Signin = () => {

   return  (
            <>
            {  <React.Fragment>
                <Formik
                    initialValues={{  email: "test@test.com", password:"123123" /* first:"", last:"" */ }} 
                    onSubmit={async values => {
                        //@ts-ignore
                        //alert(JSON.stringify(values))
                    }}
                >
                    <Form>
                        <div className="signin_component">
                            <div className="forwarding">
                                <div className="logo">
                                    NOVA {/** <img src="/logo/logo.png" height="40" alt="" /> **/}
                                </div>
                                <a href="/signup" className="goto">
                                         <FaArrowRight size={255} />
                                         Create one
                                 </a>
                                
                            </div>
                            
                            <div className="col-md-4 offset-md-4 sign pl-5 pt-3 p-3">
                                <div className="">
                                    <h1 className="text-center">Welcome </h1>
                                    <p className="text-center">Hi, let's get started</p>
                                
                                  
                                    <div className="form-group">
                                        <div className="input">
                                            <Field type="text" name="email" placeholder="ornek@gmail.com" className="form-control" />
                                            <FaEnvelope />
                                        </div>
                                    </div>
                
                                    <div className="form-group">
                                        <div className="input">
                                            <Field type="password" name="password" placeholder="*****" className="form-control" />
                                            <FaShieldAlt />
                                        </div>
                                    </div>

                                    <div className="form-group go">
                                       <a href="/account" className="btn btn-primary ">
                                           <button>Sign in</button>
                                       </a>
                                    </div>
                                    <div className="clearfix"></div>
                                   <a href="/forgotten"  className="text-center soft"><p>Forgotten</p></a>
 
                                </div>
                            </div>
                        </div>	
                    </Form>





                </Formik>
            </React.Fragment>  }
           </>
        );
}
 
 export default Signin;
